import { ArrowRightIcon, Button, Header, Paragraph } from "@datagame/ui";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import { Plan as PlanInterface } from "../../../pages/ActivatePage/ActivatePage";

import styles from "./Plan.module.scss";

const cx = classNames.bind(styles);

export interface PlanProps {
  plan: PlanInterface;
  onClick?: (plan: PlanInterface) => void;
  selected?: boolean;
}

export const Plan = ({ plan, onClick, selected }: PlanProps) => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });

  return (
    <div className={styles.planWrapper}>
      <div className={cx("plan", plan.name, { selected })}>
        <div className={cx("planHeader", plan.name)}>
          <Header variant="h6" color="secondary" className={styles.planNameHeader}>
            {plan.name}
          </Header>
          <Header variant="h3">
            {plan.price} <span className={styles.monthly}>{t("subscription:mo")}</span>
          </Header>
        </div>

        <ul className={styles.features}>
          {plan.features.map((feature, index) => {
            return (
              <li key={index}>
                <Paragraph size="small" color="secondary" className={cx("item", feature.style)}>
                  {feature.name}
                </Paragraph>
              </li>
            );
          })}
        </ul>

        {onClick && (
          <Button
            onClick={() => onClick(plan)}
            icon={<ArrowRightIcon />}
            className={styles.button}
            kind={isDesktop ? "minimal" : "primary"}
          >
            {t("subscription:getStarted")}
          </Button>
        )}
      </div>
      {selected && (
        <div className={cx("selectedPlan", plan.name)}>
          <Header variant="h6">{t("subscription:activePlan")}</Header>
        </div>
      )}
    </div>
  );
};
